import * as h2Api from '../h2Api'

export const OPEN_OR_CLOSE_MESSAGE_DIALOG = 'OPEN_OR_CLOSE_MESSAGE_DIALOG'

export const SEARCH_PUBLIC_PROFILES_SEND_MESSAGE = 'SEARCH_PUBLIC_PROFILES_SEND_MESSAGE'

export const SEARCH_PROFILE_MESSAGE_FORM_FIELD_CHANGE =
  'SEARCH_PROFILE_MESSAGE_FORM_FIELD_CHANGE'

// -------------------- Action Creators

export const openMessageDialog = (profile, byId, byCriteria) => dispatch => {
  const isById = !!byId
  const isByCriteria = !!byCriteria

  dispatch({
    type: OPEN_OR_CLOSE_MESSAGE_DIALOG,
    isOpened: true,
    byId: isById,
    byCriteria: isByCriteria,
    profile
  })
}

export const closeMessageDialog = () => dispatch => {
  dispatch({ type: OPEN_OR_CLOSE_MESSAGE_DIALOG, isOpened: false })
}

export const changeMessageFormField = (fieldName, value) => dispatch => {
  dispatch({ type: SEARCH_PROFILE_MESSAGE_FORM_FIELD_CHANGE, fieldName, value })
}

export const sendMessage = () => (dispatch, getState) => {
  const state = getState().messageDialog
  const profile = state.profile

  if (state.byCriteria) {
    const url = `/admin/users/message`

    h2Api.post(url, {
      subject: state.subject,
      body: state.body,
      criteria: getState().admin.users.list.search.criteria
    })({ type: SEARCH_PUBLIC_PROFILES_SEND_MESSAGE })(dispatch)
  } else {
    const url = state.byId
      ? `/user/message/${profile.id}`
      : `/candidates/message/${profile.name}`

    h2Api.put(url, {
      subject: state.subject,
      body: state.body
    })({ type: SEARCH_PUBLIC_PROFILES_SEND_MESSAGE })(dispatch)
  }
}
